import { AxiosPromise } from "axios";
import { GetListResult, Record } from "react-admin";
import { IPagedResultDto } from "./types";

export default {
  mapToListResult: async <RecordType extends Record = Record>(
    promise: AxiosPromise<IPagedResultDto<RecordType>>
  ): Promise<GetListResult<RecordType>> => {
    var response = await promise;
    if (!response.data) {
      return { data: [], total: 0 };
    }

    if (!response.data.items || !response.data.totalCount) {
      return { data: [], total: 0 };
    }

    return { data: response.data.items, total: response.data.totalCount };
  },
};
